var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Select',{attrs:{"options":_vm.status,"placeholder-prop":"Pilih Status","is-logo":false,"is-sub-label":false},on:{"input":_vm.filterStatus},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }